module.exports = __webpack_public_path__ + "img/cta-home-bg.ab0cb406.png";